import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Collapse } from 'antd';

import { WhyUsContainer } from './WhyUsInfo.style';
import {
  PageContainer,
  Title,
  Text,
  RowCustom,
  List,
  ListItem,
  DeviceBreakpoint,
  Icon,
} from 'components';

import { DotSVG } from 'lib/icons';
import { ReactComponent as ConciergeSVG } from 'assets/icons/mainPage/councierge.svg';
import { ReactComponent as SofaSVG } from 'assets/icons/mainPage/comfort.svg';
import { ReactComponent as SettingSVG } from 'assets/icons/mainPage/system.svg';
// import { ReactComponent as DiscountSVG } from 'assets/icons/mainPage/price.svg';
import { ReactComponent as HouseSVG } from 'assets/icons/mainPage/house.svg';

import {
  FeaturesContainer,
  FeatureItem,
  FeatureIcon,
  TitleMain,
  DotContainer,
} from '../Main.styles';

import ArrowUp from 'assets/icons/arrow-up.svg';
import ArrowDown from 'assets/icons/arrow-down.svg';

const { Panel } = Collapse;

const WhyUsInfo = () => {
  const intl = useIntl();
  const [isBlockVisible, setBlockVisibility] = useState(false);
  return (
    <>
      <DeviceBreakpoint desktopHidden>
        <FeaturesContainer padding="0 0 15px 0">
          <Title
            sizeMbl="12px"
            size="18px"
            mutedText
            marginM="23px 0 0 0"
            margin="50px 0 0 0"
            center
          >
            {intl.formatMessage({
              id: 'main-page.our-advantages',
            })}
          </Title>
          <TitleMain
            size="36px"
            sizeM="18px"
            weight="500"
            margin="0 0 31px 0"
            center
          >
            {intl.formatMessage({
              id: 'main-page.why-us',
            })}
          </TitleMain>
          <Row justify="center">
            <RowCustom width="85%" justify="space-between" justifyM="center">
              <FeatureItem>
                <FeatureIcon>
                  <HouseSVG />
                </FeatureIcon>
                <Title
                  size="14px"
                  width="100%"
                  weight="400"
                  margin="16px 0 0 0"
                >
                  {intl.formatMessage({
                    id: 'main-page.feat.help',
                  })}
                </Title>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>
                  <SettingSVG />
                </FeatureIcon>
                <Title
                  size="14px"
                  width="150px"
                  weight="400"
                  margin="16px 0 0 0"
                >
                  {intl.formatMessage({
                    id: 'main-page.feat.properties',
                  })}
                </Title>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>
                  <SofaSVG />
                </FeatureIcon>
                <Title
                  size="14px"
                  width="115px"
                  weight="400"
                  margin="16px 0 0 0"
                >
                  {intl.formatMessage({
                    id: 'main-page.feat.comforts',
                  })}
                </Title>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>
                  <ConciergeSVG />
                </FeatureIcon>
                <Title
                  size="14px"
                  width="115px"
                  weight="400"
                  margin="16px 0 0 0"
                >
                  {intl.formatMessage({
                    id: 'main-page.feat.service',
                  })}
                </Title>
              </FeatureItem>
            </RowCustom>
          </Row>
          <PageContainer
            minHeight="100%"
            bg="transparent"
            padding="0px 204px 80px 204px"
            paddingMD="4px 5% 25px 5%"
          >
            <WhyUsContainer>
              <Row className={isBlockVisible ? 'hs-open' : 'hs-close'}>
                <Col span={24} lg={16} md={12} sm={24}>
                  <Row>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="36px"
                        margin="28px 0 0 0"
                        weight="500"
                        center
                        primary
                      >
                        7
                      </Title>
                      <Title
                        size="16px"
                        width="128px"
                        margin="auto"
                        weight="400"
                        center
                      >
                        {intl.formatMessage({
                          id: 'main-page.countries',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="36px"
                        margin="28px 0 0 0"
                        weight="500"
                        center
                        primary
                      >
                        50+
                      </Title>
                      <Title
                        size="16px"
                        width="228px"
                        margin="auto"
                        weight="400"
                        center
                      >
                        {intl.formatMessage({
                          id: 'main-page.local-companies',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="36px"
                        margin="28px 0 0 0"
                        weight="500"
                        center
                        primary
                      >
                        12000+
                      </Title>
                      <Title
                        size="16px"
                        width="228px"
                        margin="auto"
                        weight="400"
                        center
                      >
                        {intl.formatMessage({
                          id: 'main-page.clients',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="36px"
                        margin="28px 0 0 0"
                        weight="500"
                        center
                        primary
                      >
                        150+
                      </Title>
                      <Title
                        size="16px"
                        width="228px"
                        margin="auto"
                        weight="400"
                        center
                      >
                        {intl.formatMessage({
                          id: 'main-page.monthly-clients',
                        })}
                      </Title>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} lg={9} md={12} sm={24}>
                  <List>
                    <ListItem iconSize="10px" margin=" 66px 0 16px 0">
                      <RowCustom wrap="wrap" justify="center">
                        <DotContainer>
                          <DotSVG />
                        </DotContainer>
                        <Text
                          size="16px"
                          color="#000"
                          center
                          margin="10px 0 0 0"
                          textAlign="center"
                          width="100%"
                        >
                          {intl.formatMessage({
                            id: 'main-page.feat.info-one',
                          })}
                        </Text>
                      </RowCustom>
                    </ListItem>
                    <ListItem iconSize="10px" margin=" 0 0 16px 0">
                      <RowCustom wrap="wrap" justify="center">
                        <DotContainer>
                          <DotSVG />
                        </DotContainer>
                        <Text
                          size="16px"
                          color="#000"
                          center
                          margin="10px 0 0 0"
                          textAlign="center"
                          width="100%"
                        >
                          {intl.formatMessage({
                            id: 'main-page.feat.info-two',
                          })}
                        </Text>
                      </RowCustom>
                    </ListItem>
                  </List>
                </Col>
              </Row>
              <Title
                center
                color="#943FA1"
                onClick={() => setBlockVisibility(!isBlockVisible)}
              >
                {isBlockVisible
                  ? intl.formatMessage({
                      id: 'main.hide',
                    })
                  : intl.formatMessage({
                      id: 'main.watch-more',
                    })}
                {isBlockVisible ? (
                  <Icon src={ArrowUp} />
                ) : (
                  <Icon src={ArrowDown} />
                )}
              </Title>
            </WhyUsContainer>
          </PageContainer>
        </FeaturesContainer>
      </DeviceBreakpoint>
      <DeviceBreakpoint tabletHidden>
        <FeaturesContainer padding="0">
          <Title
            size1100="16px"
            size768="12px"
            size="18px"
            mutedText
            margin="50px 0 0 0"
            center
          >
            {intl.formatMessage({
              id: 'main-page.our-advantages',
            })}
          </Title>
          <TitleMain
            size="36px"
            size1100="24px"
            size768="18px"
            weight="500"
            margin="0 0 50px 0"
            center
          >
            {intl.formatMessage({
              id: 'main-page.why-us',
            })}
          </TitleMain>
          <PageContainer
            minHeight="100%"
            bg="transparent"
            padding="0px 200px 80px 200px"
            paddingLaptop="0px 80px 80px 80px"
            padding1100="0px 80px 80px 80px"
          >
            <DeviceBreakpoint desktopHiddenTo1440>
              <RowCustom
                maxWidth="1033px"
                margin="0 auto"
                justify="space-between"
              >
                <Col span={24} lg={18} md={12} sm={24}>
                  <Row>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="72px"
                        sizeM="36px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                      >
                        7
                      </Title>
                      <Title size="18px" weight="500">
                        {intl.formatMessage({
                          id: 'main-page.countries',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="72px"
                        sizeM="36px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                      >
                        12000+
                      </Title>
                      <Title size="18px" weight="500">
                        {intl.formatMessage({
                          id: 'main-page.clients',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        margin="40px 0 0 0"
                        lineHeight="128%"
                        size="72px"
                        sizeM="36px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                      >
                        50+
                      </Title>
                      <Title size="18px" weight="500" width="170px">
                        {intl.formatMessage({
                          id: 'main-page.local-companies',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        margin="40px 0 0 0"
                        lineHeight="128%"
                        size="72px"
                        sizeM="36px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                      >
                        150+
                      </Title>
                      <Title size="18px" weight="500" width="160px">
                        {intl.formatMessage({
                          id: 'main-page.monthly-clients',
                        })}
                      </Title>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} lg={6} md={12} sm={24}>
                  <Row justify="end">
                    <List width="282px" margin="16px 0 0">
                      <ListItem iconSize="10px" margin=" 0 0 16px 0">
                        <RowCustom flexFlow="inherit">
                          <DotContainer>
                            <DotSVG />
                          </DotContainer>
                          <Text width="260px" size="20px">
                            {intl.formatMessage({
                              id: 'main-page.feat.info-one',
                            })}
                          </Text>
                        </RowCustom>
                      </ListItem>
                      <ListItem iconSize="10px" margin=" 0 0 16px 0">
                        <RowCustom flexFlow="inherit">
                          <DotContainer>
                            <DotSVG />
                          </DotContainer>
                          <Text width="260px" size="20px">
                            {intl.formatMessage({
                              id: 'main-page.feat.info-two',
                            })}
                          </Text>
                        </RowCustom>
                      </ListItem>
                    </List>
                  </Row>
                </Col>
              </RowCustom>
            </DeviceBreakpoint>
            <DeviceBreakpoint desktopHiddenFrom1440>
              <RowCustom
                maxWidth1100="608px"
                margin1100="0 auto"
                justify="space-between"
              >
                <Col span={24} lg={12} md={12} sm={24}>
                  <Row>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="48px"
                        sizeM="48px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                        center
                      >
                        7
                      </Title>
                      <Title center size="14px" weight="400">
                        {intl.formatMessage({
                          id: 'main-page.countries',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        lineHeight="128%"
                        size="48px"
                        sizeM="48px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                        center
                      >
                        12000+
                      </Title>
                      <Title center size="14px" weight="400">
                        {intl.formatMessage({
                          id: 'main-page.clients',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        margin="40px 0 0 0"
                        lineHeight="128%"
                        size="48px"
                        sizeM="48px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                        center
                      >
                        50+
                      </Title>
                      <Title center size="14px" weight="400" width="170px">
                        {intl.formatMessage({
                          id: 'main-page.local-companies',
                        })}
                      </Title>
                    </Col>
                    <Col span={24} lg={12} md={12} sm={24}>
                      <Title
                        ubuntu
                        margin="40px 0 0 0"
                        lineHeight="128%"
                        size="48px"
                        sizeM="48px"
                        sizeLaptopL="48px"
                        weight="bold"
                        primary
                        center
                      >
                        150+
                      </Title>
                      <Title center size="14px" weight="400" width="150px">
                        {intl.formatMessage({
                          id: 'main-page.monthly-clients',
                        })}
                      </Title>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} lg={6} md={12} sm={24}>
                  <Row justify="end">
                    <List width="242px">
                      <ListItem iconSize="10px" margin=" 0 0 16px 0">
                        <RowCustom flexFlow="inherit">
                          <DotContainer>
                            <DotSVG />
                          </DotContainer>
                          <Text width="260px" size="14px">
                            {intl.formatMessage({
                              id: 'main-page.feat.info-one',
                            })}
                          </Text>
                        </RowCustom>
                      </ListItem>
                      <ListItem iconSize="10px" margin=" 0 0 16px 0">
                        <RowCustom flexFlow="inherit">
                          <DotContainer>
                            <DotSVG />
                          </DotContainer>
                          <Text width="260px" size="14px">
                            {intl.formatMessage({
                              id: 'main-page.feat.info-two',
                            })}
                          </Text>
                        </RowCustom>
                      </ListItem>
                    </List>
                  </Row>
                </Col>
              </RowCustom>
            </DeviceBreakpoint>
          </PageContainer>
          <PageContainer
            minHeight="100%"
            bg="transparent"
            padding="0px 200px 80px 200px"
            paddingLaptop="0px 80px 80px 80px"
            padding1100="0px 80px 80px 80px"
          >
            <DeviceBreakpoint desktopHiddenTo1440>
              <Row>
                <RowCustom
                  width="100%"
                  maxWidth="1033px"
                  margin="0 auto"
                  padding="0px 40px"
                  justify="space-between"
                  justifyM="center"
                >
                  <FeatureItem>
                    <FeatureIcon>
                      <HouseSVG />
                    </FeatureIcon>
                    <Title
                      ubuntu
                      width="170px"
                      size="24px"
                      weight="500"
                      margin="16px 0 0 0"
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.help',
                      })}
                    </Title>
                  </FeatureItem>
                  <FeatureItem>
                    <FeatureIcon>
                      <SettingSVG />
                    </FeatureIcon>
                    <Title
                      ubuntu
                      width="246px"
                      size="24px"
                      weight="500"
                      margin="16px 0 0 0"
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.properties',
                      })}
                    </Title>
                  </FeatureItem>
                  <FeatureItem>
                    <FeatureIcon>
                      <SofaSVG />
                    </FeatureIcon>
                    <Title
                      ubuntu
                      width="178px"
                      size="24px"
                      weight="500"
                      margin="16px 0 0 0"
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.comforts',
                      })}
                    </Title>
                  </FeatureItem>
                  <FeatureItem>
                    <FeatureIcon>
                      <ConciergeSVG />
                    </FeatureIcon>
                    <Title
                      ubuntu
                      width="246px"
                      size="24px"
                      weight="500"
                      margin="16px 0 0 0"
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.service',
                      })}
                    </Title>
                  </FeatureItem>
                </RowCustom>
              </Row>
            </DeviceBreakpoint>
            <DeviceBreakpoint desktopHiddenFrom1440>
              <RowCustom
                margin1100="0 auto"
                maxWidth1100="608px"
                justify="center"
              >
                <RowCustom
                  width="100%"
                  justify="space-between"
                  justifyM="center"
                >
                  <FeatureItem width="140px">
                    <FeatureIcon width="90px" height="90px">
                      <HouseSVG />
                    </FeatureIcon>
                    <Title
                      size="16px"
                      width="100%"
                      weight="400"
                      margin="16px 0 0 0"
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.help',
                      })}
                    </Title>
                  </FeatureItem>
                  <FeatureItem width="140px">
                    <FeatureIcon textAlign="center" width="90px" height="90px">
                      <SettingSVG />
                    </FeatureIcon>
                    <Title
                      size="16px"
                      width="150px"
                      weight="400"
                      margin="16px 0 0 0"
                      center
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.properties',
                      })}
                    </Title>
                  </FeatureItem>
                  <FeatureItem width="140px">
                    <FeatureIcon textAlign="center" width="90px" height="90px">
                      <SofaSVG />
                    </FeatureIcon>
                    <Title
                      size="16px"
                      width="115px"
                      weight="400"
                      margin="16px 0 0 0"
                      center
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.comforts',
                      })}
                    </Title>
                  </FeatureItem>
                  <FeatureItem width="140px">
                    <FeatureIcon textAlign="center" width="90px" height="90px">
                      <ConciergeSVG />
                    </FeatureIcon>
                    <Title
                      size="16px"
                      width="115px"
                      weight="400"
                      margin="16px 0 0 0"
                      center
                    >
                      {intl.formatMessage({
                        id: 'main-page.feat.service',
                      })}
                    </Title>
                  </FeatureItem>
                </RowCustom>
              </RowCustom>
            </DeviceBreakpoint>
          </PageContainer>
        </FeaturesContainer>
      </DeviceBreakpoint>
    </>
  );
};

export { WhyUsInfo };
